import {
  Box, dialogActionsClasses, dialogTitleClasses, styled,
} from '@mui/material';
import { Spacing3, Spacing5 } from '../spacing';

export const DialogHeader = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'center',
  alignItems: 'center',
  paddingBottom: Spacing3,
  [`.${dialogActionsClasses.root}`]: {
    padding: 0,
    marginLeft: 'auto',
  },
  [`.${dialogTitleClasses.root}`]: {
    marginBottom: 0,
    paddingLeft: Spacing5,
  },
}));
